import { isEmpty } from 'ramda';
import { concat, of } from 'rxjs';

import { actions as bootstrapActions } from '@ezugi/bootstrap';
// for some reason, only in prod mode, getting `uiActions` from `bootstrapActions` doesn't work (will be `undefined`)
import { uiActions } from '@ezugi/bootstrap/src/store/actions/ui';

import { payoutsActions } from '../../actions/payouts';
import { gameResultsSelector } from '../../selectors/game';

const {
  gameActions: { game },
  betActions: { history, totalBet },
  roundActions: { round },
} = bootstrapActions;

export default function handlePlaceYourBets(socketMessage, state) {
  const {
    payouts,
  } = socketMessage;

  const gameResults = gameResultsSelector(state);

  const shouldResetGameResults = !isEmpty(gameResults?.winningBets || gameResults?.wonSidebets || {});

  return concat(of(
    uiActions.progressBar.reset(),
    payoutsActions.payouts.set({ payouts }),
    round.set({ roundSkippedPYB: false }),
    // reset prev GAME_RESULTS
    ...(shouldResetGameResults ? [
      game.set({
        gameResults: {
          ...gameResultsSelector(state),
          wonSidebets: [],
          winningBets: {},
        },
      }) ]
      : []),
    history.reset(),
    totalBet.set({ value: 0 }), // each round step is considered a new round
  ));
}
